import * as React from 'react'
import * as PropTypes from 'prop-types'
import { styled } from 'next-yak'

import * as utils from '../../utils/index.ts'
import * as S from './styles.js'

import Avatar from '../Avatar.jsx'

const Sponsor = ({ name, avatarUrl, link, mainColor }) => {
  const content = (
    <React.Fragment>
      <Avatar src={avatarUrl} alt={name} size={38} border />
      {name}
    </React.Fragment>
  )

  if (link) {
    return (
      <SponsorLink as="a" mainColor={mainColor} href={link} target="_blank" rel="noopener">
        {content}
      </SponsorLink>
    )
  }

  return <DynamicSponsor mainColor={mainColor}>{content}</DynamicSponsor>
}

const DynamicSponsor = styled(S.Sponsor)`
  color: ${(props) => props.mainColor || 'inherit'};
`

const SponsorLink = styled(DynamicSponsor).attrs((props) => ({
  color: props.mainColor || utils.colors.primary(props),
}))`
  color: ${(props) => props.color};
  display: inline-flex;
  text-decoration: none;

  &:hover {
    color: ${(props) => utils.colors.hexToRgb(props.color, 0.85)};
  }
`

Sponsor.propTypes = {
  avatarUrl: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  /** url will open in new tab */
  link: PropTypes.string,
  /** color of component */
  mainColor: PropTypes.string,
}

export default Sponsor
Sponsor.displayName = 'legacy.Sponsor'
